import { render, staticRenderFns } from "./Compensate.vue?vue&type=template&id=50fa737d&lang=pug"
import script from "./Compensate.vue?vue&type=script&lang=js"
export * from "./Compensate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports